AuthRoute = require 'mixins/authenticated-route'

App.LoyaltyProgramsCreateRoute = Em.Route.extend AuthRoute,
  controllerName: 'loyalty-programs.edit'
  templateName:   'loyalty-programs.edit'

  session: Em.inject.service()

  model: ->
    adapter = @get('store').adapterFor('application')
    host = adapter.get('host')
    headers = adapter.get('headers')
    URL = "#{host}/api/system_info/loyalty_program_kinds"
    
    ajaxProps =
      url: URL
      headers: headers
      type: 'GET'
    
    Em.$.ajax(ajaxProps).then (result) =>
      @store.createRecord 'loyalty-program',
        name: Em.I18n.t 'loyalties.new'
        additionalInfo: result
